module.exports = __webpack_public_path__ + "img/rate1.12d6bab7.svg";